module.exports = "/static/media/twitter.b2d29f08.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/twitter.svg
// module id = 1492
// module chunks = 0